import { motion } from "framer-motion";

const ScoreBars = ({ scores }) => (
  <div className="space-y-4" data-testid="score-bars">
    {scores.map((s, i) => (
      <div key={s.label}>
        <div className="mb-1.5 flex items-center justify-between text-sm">
          <span className="text-white/70">{s.label}</span>
          <span className="font-display font-bold text-volt">{s.value.toFixed(1)}</span>
        </div>
        <div className="h-1.5 overflow-hidden rounded-full bg-white/[0.07]">
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: `${s.value * 10}%` }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="h-full rounded-full bg-volt"
            data-testid={`score-bar-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
          />
        </div>
      </div>
    ))}
  </div>
);

export default ScoreBars;
